module.exports = {"id":"177934","name":"Sidney Sam","rating":"73","photo":"./data/images/photos/2/177934.png","club":{"name":"VfL Bochum","logo":"./data/images/clubs/VfLBochum.png"},"positions":["MD","ATT","MOC","AD"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/SidneySam0.json
// module id = 3949
// module chunks = 0